import axiosClient from "utils/api";
const URI = "/auth";

export const verifyLoginDetails = async (payload) => {
  const URL = `${URI}/verifyLogin`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "post",
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during verify Login Details:", error);
    throw error;
  }
};

export const checkSession = async (payload) => {
  const URL = `${URI}/checkSessionNew`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      withCredentials: true,
      params: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during checkSession:", error);
    throw error;
  }
};

export const loginWeb = async (payload) => {
  const URL = `${URI}/login`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "post",
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during login:", error);
    throw error;
  }
};

export const acceptTerms = async () => {
  const URL = `${URI}/acceptTerms`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "post",
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred while accepting terms:", error);
    throw error;
  }
};

export const logOutWeb = async (payload) => {
  const URL = `${URI}/logout`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "POST",
      data: payload,
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during Logout:", error);
    throw error;
  }
};

export const getAccountList = async (payload) => {
  const { deviceId, ...rest } = payload;
  const URL = `${URI}/listAccount/${deviceId}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "post",
      data: rest,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during get account list:", error);
    throw error;
  }
};

export const addAccount = async (payload) => {
  const URL = `${URI}/addAccount`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "post",
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during add account:", error);
    throw error;
  }
};

export const switchAccount = async (payload) => {
  const URL = `${URI}/switchAccount`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "post",
      data: payload,
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during switch account:", error);
    throw error;
  }
};

export const removeAccount = async (payload) => {
  const URL = `${URI}/removeAccount`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "post",
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during switch account:", error);
    throw error;
  }
};

export const getReviews = async () => {
  const URL = `${URI}/getReviews`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during get reviews:", error);
    throw error;
  }
};

export const authSwitchAccountNew = async (payload) => {
  const URL = `${URI}/switchAccountNew`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "post",
      data: payload,
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during auth switch account:", error);
    throw error;
  }
};
